module.exports = __webpack_public_path__ + "static/img/museen-th.9cf720c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/museen-th.png
// module id = 3FZu
// module chunks = 0